module.exports = __webpack_public_path__ + "static/media/store.83194ef1.jpg";